import http from "../common/http-common";

export async function getAllQuiz() {  
  return await http.get("/quizz");
}

export async function addQuiz(data) {
  return await http.post("/quizz", data);
}